<template>
  <div class="getIntegral">
    <el-dialog
      class="dialog-single-two"
      title="说明"
      :visible="isShow"
      width="650px"
      @close="beforeClose"
    >
      <section class="instruction">
        <div class="instruction-li">
          <p class="instruction-li-title aColor">买基金，得积分</p>
          <p class="instruction-li-con">认申购不分基金，可获得相应积分，具体可参见基金单页中购买费率所示内容。</p>
          <p class="instruction-li-tip">小提示：基金申购或认购在确认成功后获得对应积分，而非认申购当日。如：客户在T日申购
            基金，一般会在T+1日申购基金确认成功后获得积分。</p>
        </div>
        <div class="instruction-li">
          <p class="instruction-li-title aColor">财富奖励</p>
          <p class="instruction-li-con">
            客户持有资产（不包含私募基金）的每月日均资产超过50000元可获得积分，每10000元获得
            100积分。例如，A客户当月的日均资产为52000元，可获得财富奖励积分520分，B客户当月
            的日均资产为48000元，则不能获得财富奖励积分，因为当月日均资产不足50000元。
          </p>
          <p class="instruction-li-tip">
            小提示：1、财富奖励积分每月初一发放；<br>
            <span class="instruction-li-m4"></span>2、客户当月的日均资产超过50000元可获得积分，不含50000元。
          </p>
        </div>
        <div class="instruction-li">
          <p class="instruction-li-con aColor">如违规刷积分，我们有权取消你的点财通会员资格。</p>
        </div>
      </section>
    </el-dialog>
  </div>
</template>

<script>
    export default {
        name: "getIntegral",
        props:['isShow'],
        methods:{
            beforeClose(){
                this.$emit('handelClose')
            }
        }
    }
</script>

<style scoped lang="less">
</style>
